import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { Features } from '../../../featureToggles/features';
import { IPreviewProratedEnterpriseLicenseCost } from './interfaces';
import { fetchPreviewProratedEnterpriseLicenseCost } from './thunk';
import { BlockedByFeature, BlockedByFeatureType, notAvailablePropExceptIn } from '../../../featureToggles/features/utils';
import { ApiError } from '../../../services/api';

export interface IPreviewEnterpriseProratedLicenseCostState {
  loading: boolean;
  proratedLicenseCost: IPreviewProratedEnterpriseLicenseCost | undefined;
}

export type IPreviewProratedEnterpriseLicenseCostStateTrialsOfTiers = IPreviewEnterpriseProratedLicenseCostState | BlockedByFeatureType;

const initialState: IPreviewProratedEnterpriseLicenseCostStateTrialsOfTiers = notAvailablePropExceptIn({
  expected: {
    loading: false,
    proratedLicenseCost: undefined
  },
  availableIn: [Features.TrialsOfTiers]
});

const previewProratedEnterpriseLicenseCostSlice = createSlice({
  name: 'previewProratedEnterpriseLicenseCost',
  initialState,
  reducers: {
    resetValues: (state: IPreviewProratedEnterpriseLicenseCostStateTrialsOfTiers): IPreviewProratedEnterpriseLicenseCostStateTrialsOfTiers => {
      if (state === BlockedByFeature) {
        return state;
      }
      return {
        loading: false,
        proratedLicenseCost: undefined
      };
    }
  },
  extraReducers: {
    [fetchPreviewProratedEnterpriseLicenseCost?.pending.type]: (state: IPreviewProratedEnterpriseLicenseCostStateTrialsOfTiers): IPreviewProratedEnterpriseLicenseCostStateTrialsOfTiers => {
      if (state === BlockedByFeature) {
        return state;
      }
      state.loading = true;
      return state;
    },
    [fetchPreviewProratedEnterpriseLicenseCost?.fulfilled.type]: (state: IPreviewProratedEnterpriseLicenseCostStateTrialsOfTiers, action: PayloadAction<IPreviewProratedEnterpriseLicenseCost>): IPreviewProratedEnterpriseLicenseCostStateTrialsOfTiers => {
      if (state === BlockedByFeature) {
        return state;
      }
      state.loading = false;
      if (!action.payload) {
        return state;
      }
      state.proratedLicenseCost = action.payload;
      return state;
    },
    [fetchPreviewProratedEnterpriseLicenseCost?.rejected.type]: (state: IPreviewProratedEnterpriseLicenseCostStateTrialsOfTiers, action: PayloadAction<ApiError>): IPreviewProratedEnterpriseLicenseCostStateTrialsOfTiers => {
      if (state === BlockedByFeature) {
        return state;
      }
      state.loading = false;
      return state;
    }
  }
});

export const actions = {
  ...previewProratedEnterpriseLicenseCostSlice.actions
};

export default previewProratedEnterpriseLicenseCostSlice.reducer;
